module.exports = __webpack_public_path__ + "static/media/Sharing_gift.a13be5a6.png";